import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PublicLayoutComponent} from "./public-layout/public-layout.component";
import {PrivateLayoutComponent} from "./private-layout/private-layout.component";
import {PrivacyPolicyComponent} from "./privacy-policy/privacy-policy.component";
import {GdprComponent} from "./gdpr/gdpr.component";
import {PageLayoutComponent} from "./page-layout/page-layout.component";
import {NotfoundComponent} from "./notfound/notfound.component";
import {DocumentsComponent} from "./documents/documents.component";
import {PrivateResolver} from "./resolvers/private.resolver";

const routes: Routes = [
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      {
        path: '' ,
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
      },
      {
        path: "register",
        loadChildren: () => import('./register/register.module').then(m => m.RegisterModule),
      },
      {
        path: "login",
        loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
      },
      {
        path: "changepass",
        loadChildren: () => import('./chpass/chpass.module').then(m => m.ChpassModule),
      },
      {
        path: "token",
        loadChildren: () => import('./token/token.module').then(m => m.TokenModule),
      }
    ]
  },
  {
    path: 'user',
    component: PrivateLayoutComponent,
    resolve: {
      initialData: PrivateResolver
    },
    children: [
      {
        path: '' ,
        loadChildren: () => import('./select/select.module').then(m => m.SelectModule),
      },
      {
        path: "confirm",
        loadChildren: () => import('./confirm/confirm.module').then(m => m.ConfirmModule),
      },
      {
        path: "storno",
        loadChildren: () => import('./storno/storno.module').then(m => m.StornoModule),
      },
      {
        path: "reservations",
        loadChildren: () => import('./reservations/reservations.module').then(m => m.ReservationsModule),
      },
      {
        path: "success",
        loadChildren: () => import('./success/success.module').then(m => m.SuccessModule),
      }
    ]
  },
  {
    path: 'page',
    component: PageLayoutComponent,
    children: [
      {
        path: 'notfound' ,
        component: NotfoundComponent,
      },
      {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent,
      },
      {
        path: "gdpr",
        component: GdprComponent,
      },
      {
        path: "documents",
        component: DocumentsComponent,
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'page/notfound'
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
